module.exports = __webpack_public_path__ + "faa8c9f625a7b1383aaeb57fd2465ebb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/static/fonts/futurabt-bold-webfont.svg
 ** module id = 1536
 ** module chunks = 0
 **/